import { Bugsnag } from "../bugsnag";
import { graphqlApolloClient } from "../../services";
import { getAwsLink, setAwsDocument, DeleteAwsFile } from "../../graphql";
import {  Modal } from "antd"


export const DeleteDocumentAws = async ({url:key}) => {
  
  try{
    const validKey = (key ?? "").split("/").pop();

    const keyLimpia = decodeURIComponent(validKey);

    const result = await graphqlApolloClient.mutate({
      mutation: DeleteAwsFile,
      variables: { fileKey: keyLimpia }
    })

    if(result?.data?.getSignedUrlForDelete.existsInBucket){
      const deleteUrl = result?.data?.getSignedUrlForDelete.url;
      if (!deleteUrl) return false;
      const res = await fetch(deleteUrl, { method: "DELETE" });
      return res.ok
    }else{
      return true
    }
    

  }catch(e){
     Bugsnag.notify(new Error(e))
     return false;
  }
}

export const getDocumentAws = async (key, facturas = false) => {
  const validKey = (key ?? "").split("/").pop();

  const keyLimpia = decodeURIComponent(validKey);


  const result = await graphqlApolloClient.mutate({
    mutation: getAwsLink,
    variables: { key: keyLimpia }
  })

  if (result) {
    if (facturas) { return result.data.getUrl.url }
    else {
      if(result.data.getUrl.existsInBucket){
        const link = document.createElement("a");
        link.href = result.data.getUrl.url;
        link.setAttribute("download", keyLimpia);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }else{
        Modal.warning({
          title: 'No encontramos el archivo',
          content: 'El archivo ya no existe o no se puede abrir. Es necesario eliminarlo y volver a cargarlo.',
        });
      }
    }
  }
}

export const setDocument = (doc) => {

  const uploadFileToS3 = async (file) => {
    try {

      if (!(file instanceof Blob)) {
        throw new Error("El archivo no es un Blob válido");
      }

      const arrayBuffer = await file.arrayBuffer();
      const buffer = Buffer.from(arrayBuffer);


      const uint8Array = new Uint8Array(buffer);
      const fileRestored = new File([uint8Array], file.name, {
        type: file.type,
      });

      const result = await graphqlApolloClient.mutate({
        mutation: setAwsDocument,
        variables: { mimetype: file.type, filename: file.name }
      })

      const { url, fileKey } = result.data.updateFileAws;


      await fetch(url, {
        method: 'PUT',
        body: fileRestored,
        headers: {
          'Content-Type': file.type,
        }
      });

      return{
        url:  fileKey,
        name: file.name,
        type: file.type
      };

    } catch (e) {
      console.error(e);
      return null
    }
  };


  return uploadFileToS3(doc)

}